/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'typevideo': {
    width: 183.333,
    height: 183.333,
    viewBox: '0 0 183.333 183.333',
    data: '<path pid="0" fill-rule="evenodd" d="M0 91.67c0 50.62 41.04 91.66 91.67 91.66h77.08c3.45 0 6.25-2.8 6.25-6.25s-2.8-6.25-6.25-6.25H137.9c27.18-15.9 45.43-45.4 45.43-79.16C183.33 41.04 142.29 0 91.67 0 41.04 0 0 41.04 0 91.67zm12.5 0c0 43.72 35.45 79.16 79.17 79.16s79.16-35.44 79.16-79.16S135.39 12.5 91.67 12.5 12.5 47.95 12.5 91.67zm116.857 7.027a8.118 8.118 0 002.75-2.62c2.39-3.74 1.18-8.64-2.7-10.94l-50.16-29.79c-1.3-.77-2.8-1.18-4.33-1.18-4.56 0-8.25 3.56-8.25 7.95v59.09c0 1.46.41 2.89 1.19 4.13 2.36 3.75 7.44 4.95 11.34 2.67l50.16-29.31z" _fill="#fff"/>'
  }
})
